/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Extracts a centered snippet of text around a given word.
 *
 * @param {String} text The full text to process.
 * @param {String} substring The target substring to center the snippet around.
 * @returns {String} The truncated text snippet with the target word centered.
 *
 * @example
 *
 * const fullText = "This is a good text that is not truncated";
 * const centeredSnippet1 = TextCenteredAroundWord({ text: fullText, word: "good" });
 * // -> "...a good text that is not..."
 *
 * const centeredSnippet2 = TextCenteredAroundWord({ text: fullText, word: "is" });
 * // -> "...is a good text that is not..."
 *
 * const centeredSnippet3 = TextCenteredAroundWord({ text: fullText, word: "truncated" });
 * // -> "...that is not truncated"
 */

const extractContextAroundWord = ({ text, substring }) => {
  const words = text.split(' ');
  const index = words.findIndex((word) => word.includes(substring));

  if (index === -1 || substring === '') {
    // The substring was not found in the text, return the original text
    return text;
  }

  const start = Math.max(0, index - 1);
  const end = Math.min(words.length - 1, index + 1);

  const result = words.slice(start, end + 1).join(' ');

  return `...${result}...`;
};

export default extractContextAroundWord;
